import store from '@/store'
import axios from "axios";
import {findObjects, findObjectIndex} from "../class/Converter";
import {toast} from "../class/Notification";
import router from "@/router";

export default {
    namespaced: true,
    state: {
        addresses: [],
        paginationLinks: {},
        meta: {},
    },
    mutations: {
        setAddresses: (state, addresses) => {
            state.addresses = addresses
        },
        setPaginationLinks: (state, links) => {
            state.paginationLinks = links
        },
        setMeta: (state, meta) => {
            state.meta = meta
        },
        deleteAddress: (state, address) => {

            if (state.addresses.length) {
                state.addresses.splice(findObjectIndex(state.addresses, address), 1)
            }
        }

    },
    actions: {
        getPage({commit}, page) {
            let userId = store.getters['User/getUserId']
            axios.get(`user/${userId}/address?page=${page}`)
                .then(res => {
                    res = res.data.data;
                    commit('setAddresses', res.data)
                    commit('setPaginationLinks', res.links)
                    commit('setMeta', res.meta)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        deleteAddress({commit}, address) {
            let userId = store.getters['User/getUserId']

            axios.delete(`user/${userId}/address/${address.id}`)
                .then(res => {
                    const address = res.data.data;
                    commit('deleteAddress', address)

                })
        },
        createAddress({commit}, {form, redirect = false}) {
            let userId = store.getters['User/getUserId']
            axios.post(`user/${userId}/address`, form)
                .then(res => {
                    const address = res.data.data;
                    const addresses = {...store.getters['Address/getAddresses'], address}
                    toast('آدرس با موفقیت ثبت شد ', 'آدرس با موفقیت ثبت شد ')
                    if (redirect) {
                        if (router.currentRoute.query.mode != 'default-address') {
                            router.push({name: "Address"})
                        } else {
                            router.push({name: "DefaultAddresses"})
                        }
                    }
                    commit('setAddresses', addresses)
                })

        },
        async getAddress({commit}, form) {
            let userId = store.getters['User/getUserId']
            return await axios.get(`user/${userId}/address/${form.id}`)
        },
        updateAddress({commit}, form) {
            let userId = store.getters['User/getUserId']
            axios.put(`/user/${userId}/address/${form.id}`, form)
                .then(res => {
                    const address = res.data.data;
                    commit('deleteAddress', address)
                    const addresses = {...store.getters['Address/getAddresses'], address}
                    toast('عملیات با موفقیت انجام شد', 'به روز رسانی آدرس موفقیت انجام شد')
                    commit('setAddresses', addresses)
                })
        },
        setAddresses({commit}, page = 1) {
            let userId = store.getters['User/getUserId']
            axios.get(`user/${userId}/address?page=${page}`)
                .then(res => {
                    res = res.data.data;
                    commit('setAddresses', res.data)
                    commit('setPaginationLinks', res.links)
                    commit('setMeta', res.meta)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        setDefaultAddresses({commit}, page=1) {
            axios.get(`default/addresses?page=${page}`)
                .then(res => {
                    res = res.data.data;
                    commit('setAddresses', res.data)
                    commit('setPaginationLinks', res.links)
                    commit('setMeta', res.meta)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        async getDefaultAddress({commit}, form) {
            return await axios.get(`default/show/address/${form.id}`)
        },
        getOrderAddresses({commit}) {
            let userId = store.getters['User/getUserId']
            axios.get(`order/addresses/user/${userId}`)
                .then(res => {
                    res = res.data.data;
                    commit('setAddresses', res.data)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        getOrderAddressesWithoutState({commit}) {
            let userId = store.getters['User/getUserId']
            return axios.get(`order/addresses/user/${userId}`)
        },
        createAddressWithoutState({commit}, {form, redirect = false}) {
            let userId = store.getters['User/getUserId']
            return axios.post(`user/${userId}/address`, form)
        },
        setUserAddresses({commit}, form) {
            axios.get(`user/${form.user_id}/address?page=${form.page}`)
                .then(res => {
                    res = res.data.data;
                    commit('setAddresses', res.data)
                    commit('setPaginationLinks', res.links)
                    commit('setMeta', res.meta)
                })
                .catch(error => {
                    console.log(error)
                })
        },
    },
    getters: {
        getAddresses: (state) => state.addresses,
        getMeta: (state) => state.meta,
        getLinks: (state) => state.paginationLinks,
    }
}